// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.critere-section textarea {
  width: 100%;
  min-height: 12rem;
  margin-bottom: 0.5rem;
}

.financier-numero-article {
  width: 10%;
}

.financier-prix {
  width: 20%;
}

.prix-input-container {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
}

.prix-input {
  flex: 1 1;
  border: none;
  text-align: right;
  padding: 8px 4px;
  outline: none;
}

.prix-currency {
  background-color: #f5f5f5;
  padding: 8px 12px;
  color: #6B7280;
  display: block;
  white-space: nowrap;
}

.articles-table th,
.articles-table td {
  padding: 0.8rem;
  text-align: left;
  border-bottom: 1px solid #E5E7EB;
}

.articles-table th {
  background-color: rgba(215, 217, 217, 0.10);
  font-weight: 600;
}

.articles-table .prix-cell {
  text-align: right;
  font-weight: 500;
}

.definition-besoin-textarea {
  width: 100%;
  min-height: 300px; /* Hauteur minimale trois fois plus grande */
  padding: 1.5rem;
  border: 1px solid #E5E7EB;
  border-radius: 0.8rem;
  line-height: 1.5;
  font-family: inherit;
  color: #2C3948;
  resize: vertical; /* Permettre à l'utilisateur de redimensionner verticalement */
  background-color: #FFFFFF;
}

.definition-besoin-textarea:focus {
  outline: none;
  border-color: #DA7027;
  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.2);
}

/* Style pour que l'en-tête du tableau reste fixe pendant le défilement */
.articles-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1.5rem;
}

/* Assurer que les lignes s'étendent sur toute la largeur */
.articles-table tr {
  width: 100%;
  display: table;
  table-layout: fixed;
}

.total-row {
  font-weight: 700;
  font-size: 1.8rem;
  text-align: right;
}

/* Styles pour la section signataires */
.signataire-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: #fff;
  margin-bottom: 15px;
}

.signataire-details {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/composants/Candidature/Candidature.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB,EAAE,4CAA4C;EAC/D,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB,EAAE,8DAA8D;EAChF,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".critere-section textarea {\n  width: 100%;\n  min-height: 12rem;\n  margin-bottom: 0.5rem;\n}\n\n.financier-numero-article {\n  width: 10%;\n}\n\n.financier-prix {\n  width: 20%;\n}\n\n.prix-input-container {\n  display: flex;\n  align-items: center;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  overflow: hidden;\n  width: 100%;\n}\n\n.prix-input {\n  flex: 1;\n  border: none;\n  text-align: right;\n  padding: 8px 4px;\n  outline: none;\n}\n\n.prix-currency {\n  background-color: #f5f5f5;\n  padding: 8px 12px;\n  color: #6B7280;\n  display: block;\n  white-space: nowrap;\n}\n\n.articles-table th,\n.articles-table td {\n  padding: 0.8rem;\n  text-align: left;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.articles-table th {\n  background-color: rgba(215, 217, 217, 0.10);\n  font-weight: 600;\n}\n\n.articles-table .prix-cell {\n  text-align: right;\n  font-weight: 500;\n}\n\n.definition-besoin-textarea {\n  width: 100%;\n  min-height: 300px; /* Hauteur minimale trois fois plus grande */\n  padding: 1.5rem;\n  border: 1px solid #E5E7EB;\n  border-radius: 0.8rem;\n  line-height: 1.5;\n  font-family: inherit;\n  color: #2C3948;\n  resize: vertical; /* Permettre à l'utilisateur de redimensionner verticalement */\n  background-color: #FFFFFF;\n}\n\n.definition-besoin-textarea:focus {\n  outline: none;\n  border-color: #DA7027;\n  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.2);\n}\n\n/* Style pour que l'en-tête du tableau reste fixe pendant le défilement */\n.articles-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 1.5rem;\n}\n\n/* Assurer que les lignes s'étendent sur toute la largeur */\n.articles-table tr {\n  width: 100%;\n  display: table;\n  table-layout: fixed;\n}\n\n.total-row {\n  font-weight: 700;\n  font-size: 1.8rem;\n  text-align: right;\n}\n\n/* Styles pour la section signataires */\n.signataire-select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: #fff;\n  margin-bottom: 15px;\n}\n\n.signataire-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 15px;\n  background-color: #f9f9f9;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
